// src/components/TZ/nameRes/NameResults.jsx
import React, { useState } from 'react';
import { Tabs, Tag } from 'antd';
import { useSelector } from 'react-redux';
import { SearchOutlined } from '@ant-design/icons';

import SearchForm from './SearchForm';
import ResultsGrid from '../ext/ResultsGrid';
import WipoResultsGrid from '../WIPO/WipoResultsGrid';
import StickySearchPanel from '../../common/StickySearchPanel';

const NameResults = () => {
  const { results, loading, error } = useSelector((s) => s.search);
  const { lastSearchQuery, forms } = useSelector((s) => s.tz);
  const wipoLastSearchQuery = useSelector((s) => s.wipo.lastSearchQuery);
  const [, setLocalState] = useState(null);

  const mktuValue = forms?.name?.mktu;
  const formattedMktu = Array.isArray(mktuValue) ? mktuValue.join(', ') : mktuValue;
  const quantityValue = forms?.name?.quantity ?? 20;
  const textQuery = forms?.name?.name || lastSearchQuery;

  const items = [
    {
      key: 'tz',
      label: 'ТЗ',
      children: (
        <ResultsGrid
          items={results.name}
          loading={loading.name}
          error={error.name}
          loadingTip="Поиск ТЗ по названию…"
          errorTitle="Ошибка ТЗ"
          emptyTitle="ТЗ не найдены"
          requestType="По названию (ТЗ)"
          searchQuery={lastSearchQuery}
        />
      )
    },
    {
      key: 'requests',
      label: 'Заявки',
      children: (
        <ResultsGrid
          items={results.requests}
          loading={loading.requests}
          error={error.requests}
          loadingTip="Поиск заявок по названию…"
          errorTitle="Ошибка заявок"
          emptyTitle="Заявок не найдено"
          requestType="По названию (заявки)"
          searchQuery={lastSearchQuery}
        />
      )
    },
    {
      key: 'wipo',
      label: 'WIPO',
      children: (
        <WipoResultsGrid
          items={results.wipoName}
          loading={loading.wipoName}
          error={error.wipoName}
          loadingTip="Поиск WIPO по названию…"
          errorTitle="Ошибка WIPO"
          emptyTitle="Не найдено"
          requestType="WIPO: Название"
          searchQuery={wipoLastSearchQuery}
        />
      )
    }
  ];

  const compactContent = (
    <>
      <div className="sticky-search-panel__compact-body">
        {textQuery && (
          <span className="sticky-search-panel__query-text">
            <SearchOutlined style={{ marginRight: 6 }} />
            «{textQuery}»
          </span>
        )}

        <div className="sticky-search-panel__query-meta">
          {(loading.name || loading.requests || loading.wipoName) && (
            <Tag color="processing">Поиск…</Tag>
          )}
          {quantityValue && <Tag color="blue">Кол-во: {quantityValue}</Tag>}
          {formattedMktu && <Tag color="geekblue">МКТУ: {formattedMktu}</Tag>}
        </div>
      </div>
    </>
  );

  return (
    <div style={{ width: '100%', padding: 16 }}>
      <SearchForm setLocalState={setLocalState} />
      <Tabs defaultActiveKey="tz" destroyInactiveTabPane={false} items={items} />

      <StickySearchPanel
        compactContent={compactContent}
        threshold={100}
        offsetTop={12}
        overlayOnly
      />
    </div>
  );
};

export default NameResults;
